import { Arcade3DViewer } from './components/arcade-3d-viewer';

export default function Show() {
  return <Arcade3DViewer />;
}
